import { createRouter, createWebHistory } from 'vue-router'
import WorkCardView from "@/views/HomeView";
import ScanCodePageView from "@/views/ScanCodePageView";


const routes = [
    {
        path: "/",
        name: "workCard",
        component: WorkCardView,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


export default router;
